export default "__VITE_PUBLIC_ASSET__1ce3ec68__"